<template>
  <div>
    <data-filter @change="onChange" />
    <div v-if="filterForm">
      <a-row :gutter="16">
        <a-col class="customer-col" :span="24"> <project-defect :start-date="startDate" :end-date="endDate" :projects="projects" /> </a-col>
        <a-col class="customer-col" :span="12"> <defect-grade :filter-form="filterForm" /> </a-col>
        <a-col class="customer-col" :span="12"> <defect-reopen :filter-form="filterForm" /> </a-col>
        <a-col class="customer-col" :span="24"> <sprint-defect :filter-form="filterForm" /> </a-col>
        <a-col class="customer-col" :span="24"> <defect-take-time :filter-form="filterForm" /> </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import DataFilter from '@/pages/data/components/DataFilter';
import ProjectDefect from '@/pages/data/quality/components/ProjectDefect';
import DefectGrade from '@/pages/data/quality/components/DefectGrade';
import DefectReopen from '@/pages/data/quality/components/DefectReopen';
import SprintDefect from '@/pages/data/quality/components/SprintDefect';
import DefectTakeTime from '@/pages/data/quality/components/DefectTakeTime';

export default {
  components: { DataFilter, ProjectDefect, DefectGrade, DefectReopen, SprintDefect, DefectTakeTime },
  data() {
    return {
      startDate: null,
      endDate: null,
      projects: null,
      filterForm: null
    };
  },
  methods: {
    onChange(checkedDate, checkedProjectList) {
      this.startDate = checkedDate[0].format('YYYY-MM-DD');
      this.endDate = checkedDate[1].format('YYYY-MM-DD');
      this.projects = checkedProjectList;
      this.filterForm = {
        start_date: checkedDate[0].format('YYYY-MM-DD'),
        end_date: checkedDate[1].format('YYYY-MM-DD'),
        projects: checkedProjectList
      };
    }
  }
};
</script>
<style lang="less" scoped>
.customer-col {
  margin-top: 16px;
}
</style>
